const developApiUrl = "https://test.well-see.com/"; // 开发环境Api
const productionApiUrl = "https://www.wellcee.com/"; // 生产环境Api

const developPcUrl = "https://test.well-see.com/"; // 开发环境PC端访问url
const productionPcUrl = "https://www.wellcee.com/"; // 生产环境PC端访问url

function isProductionMobileHost() {
    return location.host === "m.wellcee.com";
}

// 获取接口url
export function getApiUrl() {
    let url = "";
    if (isProductionMobileHost()) {
        url = productionApiUrl;
    } else if (location.host === "dev-m.wellcee.com") {
        url = developApiUrl;
    } else {
        url = developApiUrl;
    }
    return url;
}

// 获取pc端访问url
export function getPcUrl() {
    let url = "";
    if (isProductionMobileHost()) {
        url = productionPcUrl;
    } else if (location.host === "dev-m.wellcee.com") {
        url = developPcUrl;
    } else {
        url = developPcUrl;
    }
    return url;
}
